export default [
    {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Esperant la firma del Taxador',
        name_es: '1/6 - Esperando la firma del Tasador',
        name_en: '1/6 - Needs to be signed by the Appraiser'
    },
    {
        id: 2,
        level: 2,
        progress_coef: 0.333,
        name_ca: '2/6 - Firmat pel Taxador, falta la firma del Supervisor Tècnic',
        name_es: '2/6 - Firmado por el Tasador, falta la firma del Supervisor Técnico',
        name_en: '2/6 - Signed by CFO, needs to be signed by the Technical Supervisor'
    },
    {
        id: 3,
        level: 3,
        progress_coef: 0.5,
        name_ca: '3/6 - Firmat, falta enviar factura al client',
        name_es: '3/6 - Firmado, falta enviar factura al cliente',
        name_en: '3/6 - Signed, client needs to be notified to pay'
    },
    {
        id: 4,
        level: 4,
        progress_coef: 0.666,
        name_ca: '4/6 - Client notificat, falta el pagament de la factura',
        name_es: '4/6 - Cliente notificado, falta el pago de la factura',
        name_en: '4/6 - Client notified, waiting for the invoice payment'
    },
    {
        id: 5,
        level: 5,
        progress_coef: 0.833,
        name_ca: '5/6 - Factura pagada, falta enviar al client',
        name_es: '5/6 - Factura pagada, falta enviar al cliente',
        name_en: '5/6 - Invoice payed, needs to be sent to client'
    },
    {
        id: 6,
        level: 6,
        progress_coef: 1,
        name_ca: '6/6 - Pagat i enviat al client',
        name_es: '6/6 - Pagado y enviado al cliente',
        name_en: '6/6 - Payed and sent to client'
    }
]


// WEBPACK FOOTER //
// ./src/options/status_reports.js